import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();
const transaction = process.env.REACT_APP_API_TRANSACTION;

  export const getPayements = async () => {
      try {
        const response = await api.get(`/payout-accounts`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const addPaymentAccount = async (data) => {
      try {
        const response = axios.post(`${transaction}/manage/pay-out-account/mobile?merchant=${data?.merchantId}`, data,
          {
            headers: {
              Authorization: `Bearer ${data?.token}`
            },
          }
        );
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updatePayment = async (id,data) => {
      try {
        const response = await api.put(`${transaction}/manage/pay-out-accounts/mobile?merchant=${data?.merchantId}&id=${id}`, data,
          {
            headers: {
              Authorization: `Bearer ${data?.token}`
            }
          }
        );
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAccountsPaiementByMerchantId = async (id, token) => {
      try {
        const response = await axios.get(`${transaction}/manage/pay-out-account/mobile?merchant=${id}`);
        return response?.data;
      } catch (error) {
        throw error;
      }
  };
  
  export const deletePaimentAccount = async (id) => {
      try {
        const response = await api.delete(`${transaction}/manage/pay-out-accounts/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const handlePaymentAction = async (action, id) => {
    try {
      let response;
      const url = `/payment-methods/${action}/${id}`;
  
      if (action === "activate" || action === "deactivate") {
        response = await api.put(url);
      } else if (action === "delete") {
        response = await api.delete(`/payment-methods/${id}`);
      } else {
        throw new Error("Action inconnue");
      }
      return response;
    } catch (error) {
      console.error(`Erreur lors de l'action ${action} du paiement :`, error);
      throw error;
    }
  };

  export const getVersementByBusinessId = async (props) => {
    try {
      const response = axios.get(`${transaction}/manage/pay-out/business?business=${props?.busId}`,
        {
          headers: {
            Authorization: `Bearer ${props?.token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getVersementByMerchandId = async (props) => {
    try {
      const response = axios.get(`${transaction}/manage/pay-out/merchant?merchant=${props?.merchandId}`,
        {
          headers: {
            Authorization: `Bearer ${props?.token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const getPaiementMethodeBycountryCode= async (countryCode) => {
      try {
        const response = await axios.get(`${transaction}/payment-method/cinet-pay/${countryCode}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  
    export const getPaymentByBusinessId = async (props) => {
    try {
      const response = axios.get(`${transaction}/manage/pay-in/business?business=${props?.busId}`,
        {
          headers: {
            Authorization: `Bearer ${props?.token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getPaymentByMerchandId = async (props) => {
    try {
      const response = axios.get(`${transaction}/manage/pay-in/merchant?merchant=${props?.merchandId}`,
        {
          headers: {
            Authorization: `Bearer ${props?.token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };